import { JackpotLevel, JackpotValue2 } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { Size, LogGroup, Scale } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";

export class JackpotDisplay1screen extends IJackpotDisplay {
	protected view: HTMLElement = null;	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected ContainerJP4: HTMLElement = null;
	protected DragonJackpotName: HTMLElement = null;
	protected BackgroundJp4: HTMLElement = null;
	//protected DragonGold: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected ContainerJp3: HTMLElement = null;
	protected GrandJackpotName: HTMLElement = null;
	protected BackgroundJp3: HTMLElement = null;
	protected GrandJackpotHead: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected ContainerJp2: HTMLElement = null;
	protected BackgroundJp2: HTMLElement = null;
	protected MinorJackpotName: HTMLElement = null;
	//protected DragonGreen: HTMLElement = null;
	
	protected ContainerJp1: HTMLElement = null;
	protected MiniJackpotName: HTMLElement = null;
	protected BackgroundJp1: HTMLElement = null;
	
	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	// protected diamondSpriteAnim: CanvasSprite = null;
	// protected diamondLocation: Point = new Point(8,-34);
	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected DiamondSpriteJackpot: CanvasSprite;
	protected RubySpriteJackpot: CanvasSprite;
	protected EmeraldSpriteJackpot: CanvasSprite;
	protected SapphireSpriteJackpot: CanvasSprite;


	//protected titleSpriteAnim: CanvasSprite = null;
	//protected titleStartTimer: IRandomInterval = null;


	protected jp1text: JackpotText = null;
	protected jp2text: JackpotText = null;
	protected jp3text: JackpotText = null;
	protected jp4text: JackpotText = null;

	protected moneyFormatter: MoneyFormatter = new MoneyFormatter(1);

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayOrtiz");

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval[] = [];

	protected allJpSpriteAnim: CanvasSprite[] = [];

	public constructor(param : JackpotDisplayParams) {
		super(param)

		this.systemContext = param.systemContext.CreateSubContext("JackpotDisplayOrtiz");

		this.resid = param.resid.Add("JackpotDisplayOrtiz");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayOrtiz");

		this.screenProtocol = param.screenProtocol;
		//this.logGroup.SetSpecificName(this.name);
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";

		//this.viewSize = multigameParams.viewSize;
		this.viewSize = param.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.overflow = "hidden";
		this.view.style.top = Scale.Ypx(0);
		this.view.style.left = Scale.Xpx(0);
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";

		

	}

	protected JpShowFinish(message: PickBonusMessages.JpShowFinish) {
		this.allJpSpriteAnim.forEach((anim: CanvasSprite) => {
			if (anim.sprite.Running()) {
				anim.Repeat(false);
			}
		});

		this.StartAnimations();
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		this.LoadFrames(resourceManager);

		await this.jackpotTextMapping[JackpotLevel.Jp4].PrepareResources(resourceManager);
		await this.jackpotTextMapping[JackpotLevel.Jp3].PrepareResources(resourceManager);
		await this.jackpotTextMapping[JackpotLevel.Jp2].PrepareResources(resourceManager);
		await this.jackpotTextMapping[JackpotLevel.Jp1].PrepareResources(resourceManager);
	}

	protected LoadFrames(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/DragonJackpot_1Screen.png", this.resid.ScopedResourceName(["jp4", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/frame_jackpots.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/frame_jackpots.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/frame_jackpots.png", this.resid.ScopedResourceName(["jp1", "image"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/DRAGON-JACKPOT-NAME.png", this.resid.ScopedResourceName(["DragonJackpotName"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/GRAND-JACKPOT-NAME.png", this.resid.ScopedResourceName(["GrandJackpotName"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/MINI-JACKPOT-NAME.png", this.resid.ScopedResourceName(["MiniJackpotName"])));
		resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/MINOR-JACKPOT-NAME.png", this.resid.ScopedResourceName(["MinorJackpotName"])));
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
	}



	

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		//create Container Jp
		this.createContainerJp(resourceManager);
		//create Title Name Jackpot  
		this.createTitleJpContainer(resourceManager);		
		//add jackpot Text Value
		await this.createJPText(resourceManager);
		//enable Update Values 

		this.Update();
        this.started = true;
        if (this.jackpotValuesCache != null)
        {
            this.UpdateValues(this.jackpotValuesCache);
            this.jackpotValuesCache = null;
        }
		
	}

	protected createContainerJp(resourceManager : IReadOnlyResourceManager){
		//DragonJackpot Container 
		this.ContainerJP4 = document.createElement("div");
		this.ContainerJP4.setAttribute("class", "BackgroundJp4");
		this.ContainerJP4.classList.add(this.resid.ScopedResourceName("BackgroundJp4"));
		this.ContainerJP4.style.position = "absolute";
		this.ContainerJP4.style.right = Scale.Xpx(0);
		this.ContainerJP4.style.top = Scale.Ypx(0);
		this.ContainerJP4.style.width = Scale.Wpx(972);
		this.ContainerJP4.style.height = Scale.Hpx(187);
		this.view.appendChild(this.ContainerJP4);

		


		
		//GrandJackpot Container
		this.BackgroundJp4 = document.createElement("div");
		this.BackgroundJp4.setAttribute("class", "BackgroundJp4");
		this.BackgroundJp4.classList.add(this.resid.ScopedResourceName("BackgroundJp4"));
		this.BackgroundJp4.style.position = "absolute";
		this.BackgroundJp4.style.bottom = Scale.Ypx(0);
		this.BackgroundJp4.style.right = Scale.Xpx(0);
		this.BackgroundJp4.style.width = "100%";
		this.BackgroundJp4.style.height = Scale.Hpx(141);
		this.ContainerJP4.appendChild(this.BackgroundJp4);



		
		//GrandJackpot Container
		this.ContainerJp3 = document.createElement("div");
		this.ContainerJp3.setAttribute("class", "ContainerJp3");
		this.ContainerJp3.classList.add(this.resid.ScopedResourceName("ContainerJp3"));
		this.ContainerJp3.style.position = "absolute";
		this.ContainerJp3.style.top = Scale.Ypx(250);
		this.ContainerJp3.style.right = Scale.Xpx(0);
		this.ContainerJp3.style.width = Scale.Wpx(383);
		this.ContainerJp3.style.height = Scale.Hpx(135);
		this.view.appendChild(this.ContainerJp3);

		//GrandJackpot Container
		this.BackgroundJp3 = document.createElement("div");
		this.BackgroundJp3.setAttribute("class", "BackgroundJp3");
		this.BackgroundJp3.classList.add(this.resid.ScopedResourceName("BackgroundJp3"));
		this.BackgroundJp3.style.position = "absolute";
		this.BackgroundJp3.style.bottom = Scale.Ypx(0);
		this.BackgroundJp3.style.right = Scale.Xpx(0);
		this.BackgroundJp3.style.width = Scale.Wpx(383);
		this.BackgroundJp3.style.height = Scale.Hpx(86);
		this.ContainerJp3.appendChild(this.BackgroundJp3);

		//Emerald Jackpot
		this.ContainerJp2 = document.createElement("div");
		this.ContainerJp2.setAttribute("class", "ContainerJp2");
		this.ContainerJp2.classList.add(this.resid.ScopedResourceName("emerald"));
		this.ContainerJp2.style.position = "absolute";
		this.ContainerJp2.style.top = Scale.Ypx(450);
		this.ContainerJp2.style.right = Scale.Xpx(0);
		this.ContainerJp2.style.width = Scale.Wpx(360);
		this.ContainerJp2.style.height = Scale.Hpx(128);		
		this.view.appendChild(this.ContainerJp2);

		//GrandJackpot Name
		this.MinorJackpotName = document.createElement("div");
		this.MinorJackpotName.classList.add(this.resid.ScopedResourceName("MinorJackpotName"));
		this.MinorJackpotName.style.position = "absolute";
		this.MinorJackpotName.style.right = Scale.Xpx(0);
		this.MinorJackpotName.style.top = Scale.Ypx(0);
		this.MinorJackpotName.style.width = "100%";
		this.MinorJackpotName.style.height = Scale.Hpx(51);
		this.ContainerJp2.appendChild(this.MinorJackpotName);

		//GrandJackpot Container
		this.BackgroundJp2 = document.createElement("div");
		this.BackgroundJp2.setAttribute("class", "BackgroundJp2");
		this.BackgroundJp2.classList.add(this.resid.ScopedResourceName("BackgroundJp2"));
		this.BackgroundJp2.style.position = "absolute";
		this.BackgroundJp2.style.bottom = Scale.Ypx(0);
		this.BackgroundJp2.style.right = Scale.Xpx(0);
		this.BackgroundJp2.style.width = "100%";
		this.BackgroundJp2.style.height = Scale.Hpx(86);
		this.ContainerJp2.appendChild(this.BackgroundJp2);

		//Shappire Jackpot
		this.ContainerJp1 = document.createElement("div");
		this.ContainerJp1.setAttribute("class", "ContainerJp1");
		this.ContainerJp1.classList.add(this.resid.ScopedResourceName("ContainerJp1"));
		this.ContainerJp1.style.position = "absolute";
		this.ContainerJp1.style.top = Scale.Ypx(632);
		this.ContainerJp1.style.right = Scale.Xpx(0);
		this.ContainerJp1.style.width = Scale.Wpx(343);
		this.ContainerJp1.style.height = Scale.Hpx(128);	
		this.view.appendChild(this.ContainerJp1);


		//GrandJackpot Container
		this.BackgroundJp1 = document.createElement("div");
		this.BackgroundJp1.setAttribute("class", "BackgroundJp1");
		this.BackgroundJp1.classList.add(this.resid.ScopedResourceName("BackgroundJp1"));
		this.BackgroundJp1.style.position = "absolute";
		this.BackgroundJp1.style.bottom = Scale.Ypx(0);
		this.BackgroundJp1.style.right = Scale.Xpx(0);
		this.BackgroundJp1.style.width = "100%";
		this.BackgroundJp1.style.height = Scale.Hpx(78);
		this.ContainerJp1.appendChild(this.BackgroundJp1);

		//JACkPOT NAME 
		this.BackgroundJp4.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp4", "image"])).CssBackground();
		this.BackgroundJp4.style.backgroundPosition = "center";
		this.BackgroundJp4.style.backgroundRepeat = "no-repeat";
		this.BackgroundJp4.style.backgroundSize = "contain";
		//DRAGONJACKOT CONTAINER 
		this.BackgroundJp3.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp3", "image"])).CssBackground();
		this.BackgroundJp3.style.backgroundPosition = "center";
		this.BackgroundJp3.style.backgroundRepeat = "no-repeat";
		this.BackgroundJp3.style.backgroundSize = "contain";

		//SIMPLE PNG
		this.BackgroundJp2.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp2", "image"])).CssBackground();
		this.BackgroundJp2.style.backgroundPosition = "bottom";
		this.BackgroundJp2.style.backgroundRepeat = "no-repeat";
		this.BackgroundJp2.style.backgroundSize = "contain";

	
		//SIMPLE PNG
		this.BackgroundJp1.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp1", "image"])).CssBackground();
		this.BackgroundJp1.style.backgroundPosition = "bottom";
		this.BackgroundJp1.style.backgroundRepeat = "no-repeat";
		this.BackgroundJp1.style.backgroundSize = "contain";		



	}

	protected async createJPText(resourceManager: IReadOnlyResourceManager){

		let jp4TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("White"),
			width: Scale.W(908),
			height: Scale.H(104),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
			//fontHeight : Scale.fh(300)
		}

		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(36);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.bottom = Scale.Ypx(19); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.ContainerJP4.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());


		let jp3TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(340),
			height: Scale.H(61),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(20);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.bottom = Scale.Ypx(12);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.BackgroundJp3.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());



		let jp2TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(322),
			height: Scale.H(58),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(19);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.bottom = Scale.Ypx(11);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.BackgroundJp2.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());


		let jp1TextParams: JackPotTextParams={
			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(312),
			height: Scale.H(55),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(3);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.bottom = Scale.Ypx(17);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.BackgroundJp1.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());

		//Aqui debo de meter los otros textos verdad

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();
		
 		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		

	}

	protected createTitleJpContainer (resourceManager : IReadOnlyResourceManager){
		//aqui mueve los contenedores de los titles 

		//DRAGONJACKOT TITLE
		//DragonJackpot Name
		this.DragonJackpotName = document.createElement("div");
		this.DragonJackpotName.classList.add(this.resid.ScopedResourceName("DragonJackpotName"));
		this.DragonJackpotName.style.position = "absolute";
		this.DragonJackpotName.style.right = Scale.Xpx(0);
		this.DragonJackpotName.style.top = Scale.Ypx(0);
		this.DragonJackpotName.style.width = "100%";
		this.DragonJackpotName.style.height = Scale.Hpx(61);
		this.ContainerJP4.appendChild(this.DragonJackpotName);

		this.DragonJackpotName.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["DragonJackpotName"])).CssBackground();
		this.DragonJackpotName.style.backgroundPosition = "center";
		this.DragonJackpotName.style.backgroundRepeat = "no-repeat";
		this.DragonJackpotName.style.backgroundSize = "contain";

		//GrandJackpot Name
		this.GrandJackpotName = document.createElement("div");
		this.GrandJackpotName.classList.add(this.resid.ScopedResourceName("GrandJackpotName"));
		this.GrandJackpotName.style.position = "absolute";
		this.GrandJackpotName.style.right = Scale.Xpx(0);
		this.GrandJackpotName.style.top = Scale.Ypx(0);
		this.GrandJackpotName.style.width = Scale.Wpx(373);
		this.GrandJackpotName.style.height = Scale.Hpx(51);
		this.ContainerJp3.appendChild(this.GrandJackpotName);
		
		//DRAGONJACKOT TITLE
		this.GrandJackpotName.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["GrandJackpotName"])).CssBackground();
		this.GrandJackpotName.style.backgroundPosition = "bottom";
		this.GrandJackpotName.style.backgroundRepeat = "no-repeat";
		this.GrandJackpotName.style.backgroundSize = "contain";


		//GrandJackpot Name
		this.MinorJackpotName = document.createElement("div");
		this.MinorJackpotName.classList.add(this.resid.ScopedResourceName("MinorJackpotName"));
		this.MinorJackpotName.style.position = "absolute";
		this.MinorJackpotName.style.right = Scale.Xpx(0);
		this.MinorJackpotName.style.top = Scale.Ypx(0);
		this.MinorJackpotName.style.width = "100%";
		this.MinorJackpotName.style.height = Scale.Hpx(51);
		this.ContainerJp2.appendChild(this.MinorJackpotName);

		
		//SIMPLE PNG
		this.MinorJackpotName.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["MinorJackpotName"])).CssBackground();
		this.MinorJackpotName.style.backgroundPosition = "bottom";
		this.MinorJackpotName.style.backgroundRepeat = "no-repeat";
		this.MinorJackpotName.style.backgroundSize = "contain";


		this.MiniJackpotName = document.createElement("div");
		this.MiniJackpotName.classList.add(this.resid.ScopedResourceName("MiniJackpotName"));
		this.MiniJackpotName.style.position = "absolute";
		this.MiniJackpotName.style.right = Scale.Xpx(0);
		this.MiniJackpotName.style.top = Scale.Ypx(0);
		this.MiniJackpotName.style.width = "100%";
		this.MiniJackpotName.style.height = Scale.Hpx(51);
		this.ContainerJp1.appendChild(this.MiniJackpotName);

		//SIMPLE PNG
		this.MiniJackpotName.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["MiniJackpotName"])).CssBackground();
		this.MiniJackpotName.style.backgroundPosition = "bottom";
		this.MiniJackpotName.style.backgroundRepeat = "no-repeat";
		this.MiniJackpotName.style.backgroundSize = "contain";
		
	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
	}

	public StopAnimations(): void {
	
	}

	public StartAnimations(): void {

	
	}


    protected started: boolean = false;
    protected jackpotValuesCache: JackpotValue2[] = null;

	public override UpdateValues(jackpotValues: JackpotValue2[]): void {
		
        if (!this.started)
        {
            this.jackpotValuesCache = jackpotValues;
            return;
        }

		if(jackpotValues != null){
			let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);

			if (jp1 != null) {

				//this.sapphirevalue.innerHTML = this.moneyFormatter.FormatCurrency(jp1.value);
				this.jackpotTextMapping[JackpotLevel.Jp1]?.SetTarget(jp1.CurrentMultipliedValue);
			}

			let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2); 
			if (jp2 != null) {

				//this.emeraldvalue.innerHTML = this.moneyFormatter.FormatCurrency(jp2.value);
				this.jackpotTextMapping[JackpotLevel.Jp2]?.SetTarget(jp2.CurrentMultipliedValue);
			}

			let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
			if (jp3 != null) {
				this.jackpotTextMapping[JackpotLevel.Jp3]?.SetTarget(jp3.CurrentMultipliedValue);
				//this.rubyvalue.innerHTML = this.moneyFormatter.FormatCurrency(jp3.value);
			}
			
			let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
			if (jp4 != null) {
				this.jackpotTextMapping[JackpotLevel.Jp4]?.SetTarget(jp4.CurrentMultipliedValue);
				console.log(jp4.CurrentMultipliedValue);
				//this.diamondvalue.innerHTML = this.moneyFormatter.FormatCurrency(jp4.value);
			}
		}
		}
		//i dont know what do 
		public TitleHide() {
			//this.titleSpriteAnim.Hide();
			//this.titleSpriteAnim.Stop();
		}
		public TitleShow() {
			//this.titleSpriteAnim.Show();
			//this.titleStartTimer.Start()
		}	
		public override Reset() {
			//console.log("Reset JackpotValues");
		}
	
		public override Resume() {
			//console.log("Resume JackpotValues");
		}
	
		public override Pause() {
			//console.log("Pause JackpotValues");
		}
	}
